import { PickInvisible } from '../result/pick-invisible';
import { IPickPreCheckError, PreCheckErrorMixin } from './pre-check-error';

/**
 * Raised when market/option/price visibility is false.
 */
export class PickLockedPreCheckError extends PreCheckErrorMixin(PickInvisible) implements IPickPreCheckError {
    constructor(pickId: string) {
        super(pickId);
    }
}
